import { ApiPromise } from '@/types';
import { HTTP } from '@/utils';
import { MEDICAID_FEATUREABLE_TYPE } from '@/enum';
import { useAuthStore } from '@/store';

export default class RelayHubService {
  static resource = 'features/';
  static medicaidResource = `${this.resource}medicaid`;
  static organizationResource = `${this.resource}organizations`;

  static fetchRelayHubConfig(): ApiPromise {
    const resource = `tenant/${useAuthStore().masterTenantId}/relay-hub`;
    return HTTP.get(`${resource}`);
  }

  /**
   *
   * @param model_id
   * @param model (types:  states, organizations, people)
   * @returns Promise
   */
  static enableMedicaid(model_id: number, model = MEDICAID_FEATUREABLE_TYPE.STATES): ApiPromise {
    return HTTP.post(`${this.medicaidResource}/enable`, { model, model_id });
  }

  static getMedicaidBilling(id: number): ApiPromise {
    return HTTP.get(`/medicaid-person-details/${id}`);
  }

  static addMedicaidBillingNPI(payload: { person_id: number; NPI: string; organization_id: number }): ApiPromise {
    return HTTP.post(`medicaid-person-details`, payload);
  }

  static deleteMedicaidBilling(id: number): ApiPromise {
    return HTTP.delete(`medicaid-person-details/${id}`);
  }

  /**
   *
   * @param model_id
   * @param model (types:  states, organizations, people)
   * @returns Promise
   */
  static disableMedicaid(model_id: number, model = MEDICAID_FEATUREABLE_TYPE.STATES): ApiPromise {
    return HTTP.post(`${this.medicaidResource}/disable`, { model, model_id });
  }

  static fetchOrganizationFeatures(id: number): ApiPromise {
    return HTTP.get(`${this.organizationResource}/${id}`);
  }

  static fetchMedicaidEnabledStates(): ApiPromise {
    return HTTP.get(`${this.medicaidResource}/states`);
  }

  static isOrganizationEnabled(id: number): ApiPromise {
    return HTTP.get(`${this.organizationResource}/${id}`);
  }

  static connectOrganization(medicaid_district_code: string, id: number) {
    return HTTP.put(`organizations/${id}`, { medicaid_district_code });
  }
}
